<template>
  <div class="header-wrapper">

    <nav v-if="!shouldHide && $route.name == 'Login'" id="nav"
      class="navbar navbar-expand-lg navbar-dark fixed-top py-1">
      <router-link class="navbar-brand" to="/" v-if="!isLoadingAppInfo">
        <img class="mr-1" :src="logoSrc1" alt="Logo" width="28px" /><span class="text-primary"> {{ appName }}</span>
      </router-link>
      <b-navbar-toggle target="nav-collapse-login"></b-navbar-toggle>

      <b-collapse id="nav-collapse-login" is-nav>
        <ul class="navbar-nav mr-auto align-items-center">
          <template v-if="userCheck()">
            <!--<li class="nav-item">
            <router-link id="btnUpgrade" class="nav-link mr-3" to="/pricing-plans">
              <b-icon icon="gift-fill" class="mr-1"/>
              Nâng cấp ngay
            </router-link>
          </li>-->
            <li class="nav-item" v-if="isUserAdmin() || isManager() || isCustomer()">
              <router-link class="nav-link" to="/dashboard">Dashboard</router-link>
            </li>
            <li class="nav-item" v-if="isUserAdmin()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/admin-accounts') || $route.path.startsWith('/sale-accounts') || $route.path.startsWith('/customer-admin-accounts') || $route.path.startsWith('/app-names') }">
                <template v-slot:button-content>{{ $t("headerMenuAdmin") }}</template>
                <b-dropdown-item active-class="font-weight-bold" to="/admin-accounts">{{ $t("serviceAdminAccount")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/sale-accounts">{{ $t("saleAccount")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/customer-admin-accounts">{{
                  $t("customerAdminAccount")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/app-names">{{ $t("application")
                }}</b-dropdown-item>
              </b-dropdown>
            </li>
            <li v-if="isManager()" class="nav-item">
              <router-link class="nav-link" to="/customer-admin-accounts">{{ $t("customerAdminAccount") }}</router-link>
            </li>

            <template v-if="isUserAdmin() || isManager()">
              <li class="nav-item">
                <router-link class="nav-link" to="/subscription-plans">{{ $t("subscriptionPlan") }}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/customers">{{ $t("customer") }}</router-link>
              </li>
            </template>
            <li class="nav-item" v-if="shouldShowMeetingsMenu && !isManager()">
              <router-link class="nav-link" to="/meetings">{{ $t("meeting") }}</router-link>
            </li>
            <li class="nav-item" v-if="isCustomer() || isCustomerUser()">
              <router-link class="nav-link" to="/contacts">{{ $t("contact") }}</router-link>
            </li>
            <li class="nav-item" v-if="isCustomer()">
              <router-link class="nav-link" to="/customer-user-accounts">{{ $t("manageAccount") }}</router-link>
            </li>
            <li class="nav-item" v-if="(isCustomer() || isCustomerUser()) && hasWhiteboardFeature">
              <router-link class="nav-link" to="/whiteboard">Bảng trắng</router-link>
            </li>
            <!-- <li class="nav-item" v-if="isCustomer()">
            <router-link class="nav-link" to="/email-templates">{{ $t("emailTemplate") }}</router-link>
          </li> -->
            <li class="nav-item" v-if="shouldShowCalendarMenu()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/calendar') || $route.path.startsWith('/locations') }">
                <template v-slot:button-content>{{ $t("weeklyCalendar") }}</template>
                <b-dropdown-item active-class="font-weight-bold" to="/calendar">{{ $t("weeklyCalendarList")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/locations">{{ $t("meetingLocation")
                }}</b-dropdown-item>
              </b-dropdown>
            </li>
            <li class="nav-item" v-if="isUserAdmin() || isManager() || isCustomer()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/reports') }">
                <template v-slot:button-content>{{ $t("report") }}</template>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("meetingCount") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count-d"
                  v-if="isUserAdmin() || isManager()">{{ $t("outputStatistic") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count-total"
                  v-if="isUserAdmin() || isManager()">{{ $t("meetingCountTotal") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/new-users"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("newAccountsDay") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/new-contracts"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("accountsSignDay") }}</b-dropdown-item>
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/reports/error-stat"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("errorStat") }}</b-dropdown-item> -->
                <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-detail-report"
                  v-if="isCustomer()">{{
                    $t("meetingDetailReport") }}</b-dropdown-item>
              </b-dropdown>
            </li>
            <li class="nav-item" v-if="isUserSuperAdmin()||isUserAdmin()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/admin-settings') || $route.path.startsWith('/system-logs') }">
                <template v-slot:button-content>{{ $t("settings") }}</template>
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/default-account">{{ $t("defaultAccount") }}</b-dropdown-item> -->
                <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/password-policy">{{
                  $t("passwordPolicy")
                }}</b-dropdown-item>
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/ip-policy">{{ $t("ipBlacklist") }}</b-dropdown-item> -->
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/system-logs">{{ $t("systemLogs") }}</b-dropdown-item> -->
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/backup-policy">{{ $t("backup1") }}</b-dropdown-item> -->
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/port-policy">{{ $t("changeWebPort") }}</b-dropdown-item> -->
                <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/manage-config">{{
                  $t("manageConfigulation")
                }}</b-dropdown-item>
              </b-dropdown>
            </li>
            <!-- Ẩn tính năng/ upcode prod -->
            <!-- <li class="nav-item" v-if="isCustomer()">
            <router-link class="nav-link" to="/guideapi">Hướng dẫn sử dụng</router-link>
          </li> -->
          </template>
        </ul>
        <ul class="navbar-nav align-items-center">
          <template v-if="user">
            <li v-if="sessionExpCountdownStr" class="nav-item">
              <span class="nav-link" title="Thời gian còn lại của phiên đăng nhập" v-b-tooltip>
                <b-icon icon="clock" class="mr-1"></b-icon>
                {{ sessionExpCountdownStr }}
              </span>
            </li>
            <li class="nav-item">
              <router-link class="header-btn header-btn-outline" to="/meetings/new" v-if="isCustomer() || isCustomerUser()">
                <b-icon class="mr-2" icon="calendar2-plus"></b-icon> {{ $t("createCalendarMeeting") }}</router-link>
            </li>
            <li class="nav-item">
              <button class="header-btn header-btn-primary" @click="checkStorageMeeting"
                v-if="isCustomer() || isCustomerUser()">
                <b-icon class="mr-2" icon="lightning-charge"></b-icon> {{ $t("startNewMeeting")
                }}</button>
            </li>
            <li class="nav-item">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none p-0" menu-class="profile-dropdown-menu shadow"
                no-caret :class="{ active: $route.path.startsWith('/account') }">
                <template v-slot:button-content>
                  <div class="user-profile-trigger">
                    <div class="user-avatar" :style="{ background: avatarColor }">
                      {{ userInitials }}
                    </div>
                    <span class="user-name d-none d-md-inline">{{ user.name }}</span>
                    <b-icon icon="chevron-down" font-scale="0.8" class="ml-1 opacity-7"></b-icon>
                  </div>
                </template>
                <template v-if="userCheck()">
                  <b-dropdown-item to="/account">
                    <b-icon icon="info-circle" class="mr-2"></b-icon>
                    {{ $t("manageAccount") }}
                  </b-dropdown-item>
                  <b-dropdown-divider class="custom-divider-zero" v-if="isCustomer() || isCustomerUser()" />
                  <b-dropdown-item @click="onClickManageStorage" v-if="isCustomer() || isCustomerUser()">
                    <b-icon icon="folder" class="mr-2"></b-icon>
                    {{ $t("manageStorage") }}
                  </b-dropdown-item>
                  <b-dropdown-divider class="custom-divider-zero" v-if="isCustomer() || isCustomerUser() || isViewUser()" />
                  <b-dropdown-item @click="onClickWithDraw" v-if="isCustomer() || isCustomerUser() || isViewUser()">
                    <b-icon icon="arrow-repeat" class="mr-2"></b-icon>
                    {{ $t("withDrawCustomer") }}
                  </b-dropdown-item>
                </template>
                <b-dropdown-divider class="custom-divider-zero" v-if="userCheck() && (!isUserAdmin() && !isManager())" />
                <b-dropdown-item-button v-if="!isUserAdmin() && !isManager()" @click="onClickDeletePersonalData">
                  <b-icon icon="person-x" class="mr-2"></b-icon>
                  {{ $t("deletePersonalData") }}
                </b-dropdown-item-button>
                <b-dropdown-divider class="custom-divider-zero" v-if="userCheck() || (!isUserAdmin() && !isManager())" />
                <b-dropdown-item-button @click="onClickLogout">
                  <b-icon icon="box-arrow-right" class="mr-2"></b-icon>
                  {{ $t("logout") }}
                </b-dropdown-item-button>
              </b-dropdown>
            </li>
          </template>
          <li class="nav-item" v-else>
            <router-link class="nav-link  text-primary" to="/login"><i class="fas fa-key mr-2"></i>{{ $t("login")
            }}</router-link>
          </li>
          <div class="locale-changer ml-3" v-if="shouldShowI18nMenu">
            <b-dropdown variant="link" toggle-class="p-0 text-white text-decoration-none" no-caret>
              <template v-slot:button-content>
                <img class="emoji" :src="displayLangImg">
              </template>
              <b-dropdown-item @click="onClickLanguage('vi')">
                <img class="emoji" src="icon/flag-vn.png" alt="🇻🇳"> Tiếng Việt
              </b-dropdown-item>
              <b-dropdown-item @click="onClickLanguage('en')">
                <img class="emoji" src="icon/flag-en.png" alt="🇬🇧"> English
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </ul>
        <!--<div class="navbar-nav d-flex flex-row align-items-center nav-link">
        <img class="img-fluid img-circle mr-2" alt="profile pic" src="https://picsum.photos/200" width="36px">
        Quản trị hệ thống
      </div>-->
      </b-collapse>
    </nav>
    <nav v-if="!shouldHide && $route.name !== 'Login'" id="nav"
      class="navbar navbar-expand-lg bg-primary navbar-dark fixed-top py-1">
      <router-link class="navbar-brand" to="/" v-if="!isLoadingAppInfo">
        <img class="mr-1" :src="logoSrc" alt="Logo" width="28px" /><span class=""> {{ appName }}</span>
      </router-link>
      <b-navbar-toggle target="nav-collapse-main"></b-navbar-toggle>

      <b-collapse id="nav-collapse-main" is-nav>
        <ul class="navbar-nav mr-auto align-items-center">
          <template v-if="userCheck()">
            <!--<li class="nav-item">
            <router-link id="btnUpgrade" class="nav-link mr-3" to="/pricing-plans">
              <b-icon icon="gift-fill" class="mr-1"/>
              Nâng cấp ngay
            </router-link>
          </li>-->
            <li class="nav-item" v-if="isUserAdmin() || isManager() || isCustomer()">
              <router-link class="nav-link" to="/dashboard">Dashboard</router-link>
            </li>
            <li class="nav-item" v-if="isUserAdmin()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/admin-accounts') || $route.path.startsWith('/sale-accounts') || $route.path.startsWith('/customer-admin-accounts') || $route.path.startsWith('/app-names') }">
                <template v-slot:button-content>{{ $t("headerMenuAdmin") }}</template>
                <b-dropdown-item active-class="font-weight-bold" to="/admin-accounts">{{ $t("serviceAdminAccount")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/sale-accounts">{{ $t("saleAccount")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/customer-admin-accounts">{{
                  $t("customerAdminAccount")
                }}</b-dropdown-item>
                <b-dropdown-item v-if="isUserAdmin()" active-class="font-weight-bold" to="/location">
                  {{ $t("saleArea2") }}
                </b-dropdown-item>

                <b-dropdown-item active-class="font-weight-bold" to="/app-names">{{ $t("application")
                }}</b-dropdown-item>

              </b-dropdown>
            </li>
            <li v-if="isManager()" class="nav-item">
              <router-link class="nav-link" to="/customer-admin-accounts">{{ $t("customerAdminAccount") }}</router-link>
            </li>
            <!-- <li v-if="isUserAdmin()" class="nav-item">
            <router-link class="nav-link" to="/locations">Quản lý khu vực 1</router-link>
          </li> -->
            <template v-if="isUserAdmin() || isManager()">
              <li class="nav-item">
                <router-link class="nav-link" to="/subscription-plans">{{ $t("subscriptionPlan") }}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/customers">{{ $t("customer") }}</router-link>
              </li>

            </template>
            <li class="nav-item" v-if="shouldShowMeetingsMenu && !isManager()">
              <router-link class="nav-link" to="/meetings">{{ $t("meeting") }}</router-link>
            </li>
            <li class="nav-item" v-if="isCustomer() || isCustomerUser()">
              <router-link class="nav-link" to="/contacts">{{ $t("contact") }}</router-link>
            </li>
            <li class="nav-item" v-if="isCustomer()">
              <router-link class="nav-link" to="/customer-user-accounts">{{ $t("manageAccount") }}</router-link>
            </li>
            <li class="nav-item" v-if="(isCustomer() || isCustomerUser()) && hasWhiteboardFeature">
              <router-link class="nav-link" to="/whiteboard">Bảng trắng</router-link>
            </li>
            <!-- <li class="nav-item" v-if="isCustomer()">
            <router-link class="nav-link" to="/email-templates">{{ $t("emailTemplate") }}</router-link>
          </li> -->
            <li class="nav-item" v-if="shouldShowCalendarMenu()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/calendar') || $route.path.startsWith('/locations') }">
                <template v-slot:button-content>{{ $t("weeklyCalendar") }}</template>
                <b-dropdown-item active-class="font-weight-bold" to="/calendar">{{ $t("weeklyCalendarList")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/locations">{{ $t("meetingLocation")
                }}</b-dropdown-item>
              </b-dropdown>
            </li>
            <li class="nav-item" v-if="isUserAdmin() || isManager() || isCustomer()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/reports') }">
                <template v-slot:button-content>{{ $t("report") }}</template>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("meetingCount") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/output-statistic"
                  v-if="isUserAdmin() || isManager()">{{ $t("outputStatistic") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count-total"
                  v-if="isUserAdmin() || isManager()">{{ $t("meetingCountTotal") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/new-users"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("newAccountsDay") }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/reports/new-contracts"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("accountsSignDay") }}</b-dropdown-item>
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/reports/error-stat"
                  v-if="isUserAdmin() || isManager()">{{
                    $t("errorStat") }}</b-dropdown-item> -->
                <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-detail-report"
                  v-if="isCustomer()">{{
                    $t("meetingDetailReport") }}</b-dropdown-item>
              </b-dropdown>
            </li>
            <li class="nav-item" v-if="isUserSuperAdmin()||isUserAdmin()">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                :class="{ active: $route.path.startsWith('/admin-settings') || $route.path.startsWith('/system-logs') }">
                <template v-slot:button-content>{{ $t("settings") }}</template>
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/default-account">{{ $t("defaultAccount") }}</b-dropdown-item> -->
                <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/password-policy">{{
                  $t("passwordPolicy")
                }}</b-dropdown-item>
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/ip-policy">{{ $t("ipBlacklist") }}</b-dropdown-item> -->
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/system-logs">{{ $t("systemLogs") }}</b-dropdown-item> -->
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/backup-policy">{{ $t("backup1") }}</b-dropdown-item> -->
                <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/port-policy">{{ $t("changeWebPort") }}</b-dropdown-item> -->
                <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/manage-config">{{
                  $t("manageConfigulation")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/manage-config-token">{{
                  $t("manageConfigToken")
                }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/manage-config/config-list"
                  v-if="shouldShowMeetingsMenu && isUserAdmin()">{{
                    $t("manageFunction")
                  }}</b-dropdown-item>
                <b-dropdown-item active-class="font-weight-bold" to="/manage-privacy"
                  v-if="isUserAdmin()">{{
                    $t("managePrivacy")
                  }}</b-dropdown-item>
              </b-dropdown>
            </li>
            <!-- Ẩn tính năng/ upcode prod -->
            <!-- <li class="nav-item" v-if="isCustomer()">
            <router-link class="nav-link" to="/guideapi">Hướng dẫn sử dụng</router-link>
          </li> -->
          </template>
        </ul>
        <ul class="custom-navbar navbar-nav align-items-center">
          <template v-if="user">
            <li v-if="sessionExpCountdownStr" class="nav-item">
              <span class="nav-link" title="Thời gian còn lại của phiên đăng nhập" v-b-tooltip>
                <b-icon icon="clock" class="mr-1"></b-icon>
                {{ sessionExpCountdownStr }}
              </span>
            </li>
            <li class="nav-item" v-show="!isMustChange">
              <router-link class="header-btn header-btn-outline" to="/meetings/new" v-if="isCustomer() || isCustomerUser()">
                <b-icon class="mr-2" icon="calendar2-plus"></b-icon> {{ $t("createCalendarMeeting") }}</router-link>
            </li>
            <li class="nav-item" v-show="!isMustChange">
              <button class="header-btn header-btn-primary" @click="checkStorageMeeting"
                v-if="isCustomer() || isCustomerUser()">
                <b-icon class="mr-2" icon="lightning-charge"></b-icon> {{ $t("startNewMeeting")
                }}</button>
            </li>
            <li class="nav-item">
              <b-dropdown variant="link" toggle-class="nav-link text-decoration-none p-0" menu-class="profile-dropdown-menu shadow"
                no-caret :class="{ active: $route.path.startsWith('/account') }">
                <template v-slot:button-content>
                  <div class="user-profile-trigger">
                    <div class="user-avatar" :style="{ background: avatarColor }">
                      {{ userInitials }}
                    </div>
                    <span class="user-name d-none d-md-inline">{{ user.name }}</span>
                    <b-icon icon="chevron-down" font-scale="0.8" class="ml-1 opacity-7"></b-icon>
                  </div>
                </template>
                <template v-if="userCheck()">
                  <b-dropdown-item to="/account">
                    <b-icon icon="info-circle" class="mr-2"></b-icon>
                    {{ $t("manageAccount") }}
                  </b-dropdown-item>
                  <b-dropdown-divider class="custom-divider-zero" v-if="isCustomer() || isCustomerUser()" />
                  <b-dropdown-item @click="onClickManageStorage" v-if="isCustomer() || isCustomerUser()">
                    <b-icon icon="folder" class="mr-2"></b-icon>
                    {{ $t("manageStorage") }}
                  </b-dropdown-item>
                  <b-dropdown-divider class="custom-divider-zero" v-if="isCustomer() || isCustomerUser() || isViewUser()" />
                  <b-dropdown-item @click="onClickWithDraw" v-if="isCustomer() || isCustomerUser() || isViewUser()">
                    <b-icon icon="arrow-repeat" class="mr-2"></b-icon>
                    {{ $t("withDrawCustomer") }}
                  </b-dropdown-item>
                </template>
                <b-dropdown-divider class="custom-divider-zero" v-if="userCheck() && (!isUserAdmin() && !isManager())" />
                <b-dropdown-item-button v-if="!isUserAdmin() && !isManager()" @click="onClickDeletePersonalData">
                  <b-icon icon="person-x" class="mr-2"></b-icon>
                  {{ $t("deletePersonalData") }}
                </b-dropdown-item-button>
                <b-dropdown-divider class="custom-divider-zero" v-if="userCheck() || (!isUserAdmin() && !isManager())" />
                <b-dropdown-item-button @click="onClickLogout">
                  <b-icon icon="box-arrow-right" class="mr-2"></b-icon>
                  {{ $t("logout") }}
                </b-dropdown-item-button>
              </b-dropdown>
            </li>
          </template>
          <li class="nav-item" v-else>
            <router-link class="nav-link" to="/login"><i class="fas fa-key mr-2"></i>{{ $t("login") }}</router-link>
          </li>
          <div class="locale-changer ml-3" v-if="shouldShowI18nMenu">
            <b-dropdown variant="link" toggle-class="p-0 text-white text-decoration-none" no-caret>
              <template v-slot:button-content>
                <img class="emoji" :src="displayLangImg">
              </template>
              <b-dropdown-item @click="onClickLanguage('vi')">
                <img class="emoji" src="icon/flag-vn.png" alt="🇻🇳"> Tiếng Việt
              </b-dropdown-item>
              <b-dropdown-item @click="onClickLanguage('en')">
                <img class="emoji" src="icon/flag-en.png" alt="🇬🇧"> English
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </ul>
        <!--<div class="navbar-nav d-flex flex-row align-items-center nav-link">
        <img class="img-fluid img-circle mr-2" alt="profile pic" src="https://picsum.photos/200" width="36px">
        Quản trị hệ thống
      </div>-->
      </b-collapse>
    </nav>
    <b-modal v-if="isCustomer() || isCustomerUser()" id="manage-storage-modal" @hidden="onModalClosed" size="xl"
      :title="$t('manageStorage')" ok-only ok-variant="primary" :ok-title="$t('close')">
      <ManageStorageModal modal-id="manage-storage-modal" />
    </b-modal>
    <!--Modal thòa thuận mockup-->
    <b-modal id="privacy-modal" size="lg" centered hide-footer hide-header-close no-close-on-backdrop no-close-on-esc dialog-class="privacy-modal-custom" :title="privacyPolicy ? privacyPolicy.title : $t('privacyAgreementTitle')" @shown="onPrivacyModalShown">
      <PrivacyModal ref="privacyModal" modal-id="privacy-modal" :privacy-policy="privacyPolicy" />
    </b-modal>
    <!--Modal rút lại sự đồng ý mockup-->
    <b-modal id="withdraw-modal" centered hide-footer :title="$t('withDrawCustomerModalTitle')" dialog-class="withdraw-modal-custom">
      <WithdrawModal modal-id="withdraw-modal" />
    </b-modal>
    <!--Modal xóa dữ liệu cá nhân-->
    <b-modal id="delete-personal-data-modal" centered hide-footer :title="$t('deletePersonalDataRequestTitle')" dialog-class="delete-personal-data-modal-custom">
      <DeletePersonalDataModal modal-id="delete-personal-data-modal" />
    </b-modal>
    <WarmingModal ref="startMeetingWarningModal" />
</div>
</template>



<style lang="scss">
#btnUpgrade {
  color: #ffe148;
}

.icon-size {
  font-size: 100% !important;
}

.header-btn {
  font-size: 14px;
  font-weight: 600;
  border-radius: 50px;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 1.5px solid transparent;
  margin-right: 10px;
  cursor: pointer;
  outline: none;
  text-decoration: none !important;
  height: 38px;
  white-space: nowrap;

  &:hover {
    transform: translateY(-1px);
  }
}

.header-btn-primary {
  background: #ffffff;
  color: #004f9e !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #ffffff;

  &:hover {
    background: #f8fafc;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  }
}

.header-btn-outline {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.4);

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: #ffffff;
  }
}

@media (max-width: 991px) {
  .navbar-collapse {
    background: #004f9e;
    margin: 0 -1rem;
    padding: 1rem;
    border-radius: 0 0 16px 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  .header-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
    justify-content: flex-start;
    padding: 10px 20px;
    height: 44px;
    border-radius: 12px;
  }

  .nav-item {
    width: 100%;
  }

  .navbar-nav {
    padding-top: 10px;
  }
}

.user-profile-trigger {
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 4px;
  // background: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  transition: all 0.25s ease;
  color: #ffffff;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    // transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  margin-right: 8px;
  flex-shrink: 0;
  border: 1.5px solid rgba(255, 255, 255, 0.8);
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-dropdown-menu {
  border: none !important;
  border-radius: 8px !important;
  padding: 8px !important;
  min-width: 200px !important;
  margin-top: 10px !important;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;

  .dropdown-item {
    border-radius: 8px !important;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 12px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    color: #4b5563;

    &:hover {
      background-color: #f3f4f6 !important;
      color: #004f9e !important;
      transform: translateX(2px);
    }

    &.text-danger {
      color: #dc2626;
      &:hover {
        background-color: #fef2f2 !important;
        color: #b91c1c !important;
      }
    }

    &::after {
      display: none !important;
    }
  }

  .dropdown-divider {
    margin: 8px 0;
    border-top: 1px solid #f3f4f6;
  }
}

.opacity-7 {
  opacity: 0.7;
}

.custom-divider-zero hr {
  margin: 0px !important;
  padding: 0px !important;
}

</style>


<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _ from "lodash";
import * as userService from "@/service/userService";
import * as policyService from "@/service/policyService";
import * as appNamesService from "@/service/appNamesService";
import BaseComponent from "@/components/BaseComponent";
import * as meetingService from "@/service/meetingService";
import ManageStorageModal from "@/components/storage/ManageStorageModal.vue";
import PrivacyModal from "@/components/modals/PrivacyModal.vue";
import WithdrawModal from "@/components/modals/WithdrawModal.vue";
import DeletePersonalDataModal from "@/components/modals/DeletePersonalDataModal.vue";
import WarmingModal from "@/components/warning/WarmingModal.vue";
import * as customerService from "@/service/customerService";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import { StorageType } from '@/views/enums/storageType';
import * as util from "@/service/util";
import { freeStorage, confirmStartMeetingWithoutRecording, confirmStartMeetingWithoutAI, confirmStartMeetingWithoutBoth } from "@/service/meetingAlertUtils";
import {featureCode} from "@/views/enums/featureCode";
import { Status } from "@/views/enums/EnableStatus";
import { PrivacyPolicy } from "@/model/PrivacyPolicy";
@Component({
  components: { ManageStorageModal, PrivacyModal, WithdrawModal, DeletePersonalDataModal, WarmingModal }
})
export default class Header extends BaseComponent {

  isLoadingAppInfo = true;
  appName = "";
  logoSrc = "";
  logoSrc1 = "";
  routename = true;
  sessionExpCountdownStr = "";
  sessionCountdownIntervalHandler = null;

  customer = null; //thông tin khách hàng (dung lượng khách hàng đang sử dụng,...)
  activeCustomerSubscription = null; //thông tin chi tiết gói cước khách hàng (đang dùng type gói cước nào)
  enumStorageType = StorageType;
  features = []; //danh sách feature của khách hàng
  allowRecording: Status = Status.DISABLE;

  shouldHide = false;
  shouldShowI18nMenu = !!window["vnptEConferencePortalEnableI18nMenu"] || false;

  isMustChange = false;
  privacyPolicy: PrivacyPolicy | null = null;

  get userInitials() {
    if (!this.user?.name) return "?";
    const names = this.user.name.trim().split(" ");
    if (names.length === 1) return names[0].charAt(0).toUpperCase();
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  }

  get avatarColor() {
    if (!this.user?.name) return "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
    const colors = [
      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      "linear-gradient(135deg, #2af598 0%, #009efd 100%)",
      "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    ];
    let hash = 0;
    for (let i = 0; i < this.user.name.length; i++) {
      hash = this.user.name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  }

  /// Ngưỡng dung lượng tối thiểu để sử dụng được chức năng ghi hình
  readonly thresholdStorage = 200;

  mounted() {

    const user = userService.getCurrentUser();
    if (user) {
      if (user.mustChangePassword && !userService.isSsoLogin()) {
        this.isMustChange = true;
      } else {
        this.isMustChange = false;
      }
    } else {

    }
    //
    this.getAppInfo();
    this.checkPrivacyAgreement();

    // Load customer features early so feature-gated menus (e.g. whiteboard) render correctly.
    if (this.isCustomer() || this.isCustomerUser()) {
      this.getFeatureCustomer();
    }

  }

  async getAppInfo() {
    try {
      // const router = userRouter();
      if (this.$route.name == "Login") {

        this.routename = true;
      } else {

        this.routename = false;
      }
      console.log(this.$route.name);
      this.isLoadingAppInfo = true;
      const appInfo = await appNamesService.getCurrent();
      this.appName = appInfo.name;
      this.logoSrc = appInfo.logo;

    } catch (e) {
      // console.error(e);
    } finally {
      document.title = this.appName = this.appName || "VNPT GoMeet Portal";
      this.logoSrc = this.logoSrc || "images/logoVNPT.png";
      this.logoSrc1 = this.logoSrc1 || "images/logoVNPT.svg";
      this.isLoadingAppInfo = false;
    }
  }

  async checkPrivacyAgreement() {
    if (this.user && !this.isUserAdmin()) {
      try {
        const [res, policy] = await Promise.all([
          policyService.getActivePolicyConsentStatus(),
          policyService.getLatestActivePrivacyPolicy()
        ]);

        this.privacyPolicy = policy;

        if (this.privacyPolicy && res && (res.currentAgreedVersion !== res.latestRequiredVersion || res.isCompliant === false)) {
          this.$bvModal.show("privacy-modal");
        }
      } catch (e) {
        console.error("Error checking privacy agreement status:", e);
      }
    }
  }

  setupSessionCountdown() {
    this.sessionCountdownIntervalHandler = setInterval(() => {
      const expTime = userService.getTokenExpTime();
      if (expTime) {
        const duration = expTime - new Date().getTime() / 1000;
        const hours = Math.floor(duration / 3600);
        const mins = Math.floor((duration % 3600) / 60).toString().padStart(2, "0");
        this.sessionExpCountdownStr = `${hours}h ${mins}m`;

      } else {
        this.sessionExpCountdownStr = "";
      }
    }, 1000);
  }

  shouldShowCalendarMenu(): boolean {
    return window["vnptEConferencePortalShowCalendarMenu"] && (this.isCustomer() || this.isCustomerUser());
  }

  get shouldShowMeetingsMenu(): boolean {
    return ["Admin", "SupperAdmin", "Manager", "Customer", "User", "View"].includes(this.user?.role);
  }

  onClickLogout() {
    userService.signOut();
  }

  onClickDeletePersonalData() {
    this.$bvModal.show("delete-personal-data-modal");
  }

  onClickLanguage(locale) {
    localStorage.setItem("vue-i18n-locale", locale);
    location.reload();
  }

  destroyed() {
    clearInterval(this.sessionCountdownIntervalHandler);
  }

  async onClickStartNewMeeting() {
    try {
      this.showLoading();
      const res = await meetingService.startNewMeeting();
      // this.table.refresh();
      open(res.startUrl);
      location.reload();

    } catch (e) {
      this.handleStartMeetingError(e);
    } finally {
      this.hideLoading();
    }
  }

  onClickWithDraw() {
    this.$bvModal.show("withdraw-modal");
  }

  onModalClosed() {
    this.$emit("manage-storage-modal"); // 👈 emit ra ngoài
  }

  onPrivacyModalShown() {
    (this.$refs.privacyModal as any)?.handleScroll();
  }
  ///Mở modal quản lý dung lượng lưu trữ
  onClickManageStorage() {
    this.$bvModal.show("manage-storage-modal");
  }

  ///Gọi api lấy các thông tin dung lượng của khách hàng
  async getCustomerRecording(){
    try{
      this.showLoading();
      this.customer = await customerService.getDetails(this.getUserCustomerId());
      const subscriptions = await subscriptionPlanService.getCustomerSubscription(this.getUserCustomerId());
      this.activeCustomerSubscription = subscriptions.find(it => it.isActive);
    }
    catch (e) {
      this.toastError(e);

    } finally {
      this.hideLoading();
    }
  }

  ///Gọi api lấy chức năng ghi hình của khách hàng có được bật isDefault
  async getFeatureCustomer(){
    try{
      const featureConfig = await customerService.getFeatureConfigCustomer(this.getUserCustomerId());
      const rawFeatures = featureConfig?.data?.features ?? [];
      this.features = this.isActiveFeatures(rawFeatures);

      const rawCodes = rawFeatures.map((f: any) => ({
        featureCode: f.featureCode,
        isActive: f.isActive,
        isDefault: f.isDefault,
      }));
      const activeCodes = this.features.map((f: any) => ({
        featureCode: f.featureCode,
        isActive: f.isActive,
        isDefault: f.isDefault,
      }));

      const recordFeature =
        this.features.find(f => f.featureCode === featureCode.ALLOW_RECORD) ?? null;

      this.allowRecording =
        recordFeature?.isDefault ?? Status.DISABLE;
    }
    catch (e) {
      this.toastError(e);

    } finally {
      this.hideLoading();
    }
  }

  /**
   * Lấy dung lượng trống và loại gói cước
   */
  get freeStorage(): { remainingMB: string; isEnough: boolean } {
    return freeStorage(this.customer);
  }
  /**
   * popup thông báo hết dung lượng ghi hình
   */
  async startNewMeetingNoRecord() {

    /// Hiển thị popup cảnh báo khi khởi tạo cuộc họp không đủ dung lượng
    await confirmStartMeetingWithoutRecording(
      this,
      this.customer,
      () => this.onClickStartNewMeeting(),
      () => this.onClickManageStorage()
    );
  }

  /**
   * Kiểm tra xem có sử dụng tính năng AI nào không VÀ quota bị thấp/chặn tạo cuộc họp
   * Bao gồm Chức năng AI: Tự động tóm tắt cuộc họp hoặc Chức năng phụ đề
   */
  get onQuotaAI(): boolean {
    const hasAIFeature = this.features?.some(
      f => (f.featureCode === featureCode.ALLOW_SUMMARY ||
           f.featureCode === featureCode.ALLOW_LIVECAPTION) &&
           (f.isDefault === Status.ENABLE)
    );
    if (!hasAIFeature) return false;

    return !!this.customer?.aiQuota?.isAiQuotaLowForMeeting;
  }

  get hasSummaryFeature(): boolean {
    return this.features?.some(
      f => f.featureCode === featureCode.ALLOW_SUMMARY && f.isDefault === Status.ENABLE
    ) ?? false;
  }

  get hasLiveCaptionFeature(): boolean {
    return this.features?.some(
      f => f.featureCode === featureCode.ALLOW_LIVECAPTION && f.isDefault === Status.ENABLE
    ) ?? false;
  }

  get hasWhiteboardFeature(): boolean {
    return this.features?.some(f => f.featureCode === featureCode.ALLOW_WHITEBOARD) ?? false;
  }

  /**
   * Xem xét hạn mức AI và dung lượng trước khi bắt đầu cuộc họp
   */
  async checkStorageMeeting() {
    try {
      this.showLoading();

      await this.getFeatureCustomer();
      await this.getCustomerRecording();

      if (this.onQuotaAI && this.allowRecording === Status.ENABLE && !this.freeStorage.isEnough) {
        await confirmStartMeetingWithoutBoth(
          this,
          this.customer,
          async () => { this.onClickStartNewMeeting(); },
          () => this.onClickManageStorage()
        );
        return;
      }

      if (this.onQuotaAI) {
        await confirmStartMeetingWithoutAI(
          this,
          this.customer?.aiQuota?.cycleEnd,
          this.hasSummaryFeature,
          this.hasLiveCaptionFeature,
          async () => {
            if (this.allowRecording === Status.ENABLE && !this.freeStorage.isEnough) {
              await this.startNewMeetingNoRecord();
              return;
            }
            this.onClickStartNewMeeting();
          }
        );
        return;
      }

      // 2. Không bị cản bởi AI -> Kiểm tra dung lượng ghi hình
      if (this.allowRecording === Status.ENABLE && !this.freeStorage.isEnough) {
        await this.startNewMeetingNoRecord();
        return;
      }

      /// Đủ điều kiện -> vào họp luôn
      this.onClickStartNewMeeting();
    } catch (e) {
      this.toastError(e);
    } finally {
      this.hideLoading();
    }
  }

}
</script>
